import React, { useState, useEffect } from 'react';
import EstadisticasMenores from '../components/principal/EstadisticasMenores';

const EstadisticasPage = ({ user }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6f8' }}>
      <div style={{
        maxWidth: 1400,
        margin: '0 auto',
        width: '100%',
        boxSizing: 'border-box',
        padding: isMobile ? '18px 16px 24px' : '26px 30px 30px'
      }}>
        <EstadisticasMenores user={user} />
      </div>
    </div>
  );
};

export default EstadisticasPage;
